import type { SupabaseClient } from "@supabase/supabase-js";

// Extracted from LiveTrackingSetup.tsx so the save can be unit-tested
// and so the DELETE-then-INSERT atomicity gap is replaced with a
// single RPC call. The boundary is the wake-up region for the GPS
// gating system (see CLAUDE.md → Mobile GPS gating); a missing
// boundary mid-save silently breaks the geofence path on the mobile
// app and the producer's live tracker.

export interface BoundaryPolygon {
  type: string;
  coordinates: unknown;
}

export interface SaveBoundaryResult {
  id: string;
}

/**
 * Atomically replace the festival_boundary for a briefing via the
 * upsert_festival_boundary RPC. Server-side does INSERT … ON CONFLICT
 * keyed on the partial unique index, so there is never a window in
 * which the briefing has no boundary.
 */
export async function saveFestivalBoundary(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  client: SupabaseClient<any, any, any>,
  briefingId: string,
  polygon: BoundaryPolygon,
): Promise<SaveBoundaryResult> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await (client.rpc as any)("upsert_festival_boundary", {
    p_briefing_id: briefingId,
    p_polygon: polygon,
  });

  if (error) {
    // Keep the SQLSTATE: a shape the polygon trigger refuses (22023) gets
    // its own message in the editor (lib/zoneWriteError).
    throw Object.assign(new Error(`upsert_festival_boundary failed: ${error.message}`), {
      code: error.code,
    });
  }
  if (!data || typeof data !== "object" || !("id" in data)) {
    throw new Error("upsert_festival_boundary returned unexpected shape");
  }
  return data as SaveBoundaryResult;
}
